<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import axios from 'axios'
import md5 from 'js-md5'
import route from './router'
import { $postAxios } from '@/api/http.js'
export default {
  name: 'App',
  data() {
    return {
    }
  }, 
  mounted() {
    // 61.11.175.255
    document.getElementById('app').style.display = 'block';
    // 移除 loading，直接显示页面
    document.getElementById('appLoading').style.display = 'none';
    sessionStorage.setItem("init", true);

    // 检查是否已经有路由
    if (this.$route.path === '/') {
      // 默认跳转到 PC 端主页
      this.$router.replace("/pc-home").catch(err => {});
    }
  },
  methods: {
    
    // 判断是否是手机端，如果是，返回true
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue